import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-national-microchipping-month-popup',
  standalone: true,
  imports: [],
  templateUrl: './national-microchipping-month-popup.component.html',
  styleUrl: './national-microchipping-month-popup.component.scss'
})
export class NationalMicrochippingMonthPopupComponent implements OnInit {
  readonly CAT_COMPETITION_LINK = "https://gbr01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmailchi.mp%2F9dda42131719%2Fidenticare&data=05%7C02%7CVicky%40identicare.pet%7C583261059f2846db9b6d08dd9d1c3ed9%7Cf68ebd98d29f49edac2ee589a4bdb782%7C0%7C0%7C638839466864290752%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=St%2FARrD1ze6kfHs6qXqlPLVB7w9Rll%2BcNtWolwOBEfQ%3D&reserved=0";
  readonly DOG_COMPETITION_LINK = "https://docs.google.com/forms/d/e/1FAIpQLSf-owUqn-4xqkw8i6L-QkfvTPnKv2gL8Y_XtLzJ8ka3fF1gug/viewform";

  public popupTitle: string = "Happy National Microchipping Month!";
  public popupSubTitle: string = "Enter our giveaway for the chance to win one of five Gus and Bella cat toy gift boxes.";
  public popupButtonText: string = "Enter Giveaway"
  public popupButtonLink: string = this.CAT_COMPETITION_LINK;
  @Input() petType: string = 'cat';

  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  ngOnInit(): void {
    if (this.petType === 'dog') {
      this.popupSubTitle = "Enter our giveaway for the chance to win a Butternut Box prize bundle and runner up prizes.";
      this.popupButtonLink = this.DOG_COMPETITION_LINK;
    }
  }
}
